import { progressActions } from '../actions';
import { WHATSAPP_SEND, WHATSAPP_SEND_BATCH, WHATSAPP_OFICIAL_MESSAGES, WHATSAPP_TEMPLATES, WHATSAPP_TEMPLATE_UPDATE } from '../constants/Links';
import { store } from '../MainApp';
import { whatsAppOficialApi } from './createApi';


export const whatsappOficialApi = {
  // Envio individual (modal de contato do detalhe do caso). `phoneNumber` é o número
  // clicado pelo usuário: sem ele o backend resolve o destino pelo hotphone do caso.
  // `origin` diferente de 'lote' isenta o disparo das travas anti-duplicidade de lote.
  // `templateId` só vai nos templates "Envio manual", escolhidos pelo nome da Meta.
  send: async ( payload ) => {
    const state = store.getState( state => state );
    return await whatsAppOficialApi.post( WHATSAPP_SEND, { cases: [{ externalId: payload.externalId, template: payload.template, user: state.auth.userLogin, phoneNumber: payload.phoneNumber, recipientName: payload.recipientName, templateId: payload.templateId, origin: payload.origin ?? 'caso' }] } );
  },
  sendBatch: async ( payload ) => {
    const state = store.getState( state => state );
    return await whatsAppOficialApi.post( WHATSAPP_SEND_BATCH, {cases: payload.externalId.map( externalId => ({ externalId, template: payload.template, user: state.auth.userLogin }) ) } )
      .finally( () => store.dispatch( progressActions( { percent: false, message: '' } ) ) );
  },
  getMessages: async ( phoneNumber ) => {
    return await whatsAppOficialApi.get( `${WHATSAPP_OFICIAL_MESSAGES}?phone=${encodeURIComponent( phoneNumber )}` );
  },
  getChats: async ( cursor = null, operators = [], departments = [] ) => {
    const params = { operators, departments };
    if ( cursor != null ) params.cursor = cursor;
    return await whatsAppOficialApi.get( '/v1/chats', { params } );
  },
  updateOperator: async ( phoneNumber, negotiatorId ) => {
    return await whatsAppOficialApi.put( `/v1/chats/${encodeURIComponent( phoneNumber )}/operator`, { negotiatorId } );
  },
  closeChatService: async ( phoneNumber ) => {
    return await whatsAppOficialApi.put( `/v1/chats/${encodeURIComponent( phoneNumber )}/close` );
  },
  updateChat: async ( phoneNumber, { caseId, status } = {} ) => {
    const body = {};
    if ( caseId !== undefined ) body.caseId = caseId;
    if ( status !== undefined ) body.status = status;
    return await whatsAppOficialApi.put( `/v1/chats/${encodeURIComponent( phoneNumber )}`, body );
  },
  sendText: async ( { to, body, tenantId } ) => {
    return await whatsAppOficialApi.post( '/v1/messages', { to, type: 'text', body, tenantId } );
  },
  markRead: async ( whatsappMessageId, tenantId ) => {
    return await whatsAppOficialApi.post( '/v1/messages/read', { whatsappMessageId, tenantId } );
  },
  getTemplates: async () => {
    return await whatsAppOficialApi.get( WHATSAPP_TEMPLATES );
  },
  // Texto, parâmetros e formato do template na Meta + de-para salvo (`config`).
  getTemplateDetails: async ( tenantId, templateName ) => {
    return await whatsAppOficialApi.get( `/v1/admin/tenants/${tenantId}/templates/${encodeURIComponent( templateName )}` );
  },
  // Tipo no sistema + de-para dos parâmetros. `reference` vazio = "sem mapeamento".
  saveTemplateConfig: async ( id, { reference, parameters } ) => {
    return await whatsAppOficialApi.put( `${WHATSAPP_TEMPLATE_UPDATE}${id}`, { reference, parameters } );
  },
  syncTemplates: async () => {
    return await whatsAppOficialApi.post( '/v1/admin/templates/sync' );
  },
  getTenantConfig: async () => {
    return await whatsAppOficialApi.get( '/v1/tenant/config' );
  },
  createTenantConfig: async ( { tenantId, phoneNumberId, wabaId, accessToken, appSecret, displayPhoneNumber } ) => {
    return await whatsAppOficialApi.post( '/v1/admin/tenants', { tenantId, phoneNumberId, wabaId, accessToken, appSecret, displayPhoneNumber } );
  },
  updateTenantConfig: async ( tenantId, fields ) => {
    return await whatsAppOficialApi.put( `/v1/admin/tenants/${tenantId}`, fields );
  },
  subscribeWaba: async ( tenantId ) => {
    return await whatsAppOficialApi.post( `/v1/admin/tenants/${tenantId}/subscribe` );
  },
  getHealth: async () => {
    return await whatsAppOficialApi.get( '/v1/tenant/health' );
  },
  getCampaignStatus: async ( tenantId ) => {
    return await whatsAppOficialApi.get( `/v1/admin/tenants/${tenantId}/campaign/status` );
  },
  pauseCampaign: async ( tenantId ) => {
    return await whatsAppOficialApi.post( `/v1/admin/tenants/${tenantId}/campaign/pause` );
  },
  resumeCampaign: async ( tenantId ) => {
    return await whatsAppOficialApi.post( `/v1/admin/tenants/${tenantId}/campaign/resume` );
  },

};
